import {
  CreditAndRiskProposalNoteModel,
  ProposalObservationNoteModel
} from '../../credit-risk-proposals/models/credit-risk-proposal-details.model';
import {SearchOperationsProposalModel} from '../models/search-operations-proposal.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {OperationsProposalListModel} from '../models/operations-proposal-list.model';
import {environment} from 'src/environments/environment';
import {Pageable} from 'src/app/shared/models/pageable.model';
import {Observable} from 'rxjs';
import {OperationsProposalUpdateModel} from '../models/operations-proposal-update.model';
import {OperationsProposalDetailModel} from '../models/operations-proposal-details.model';
import {map} from 'rxjs/operators';
import {ExportOperationsProposalModel} from '../models/export-operations-proposal.model';
import {SearchOperationsProposalQueryModel} from '../models/search-operations-proposal-query.model';

@Injectable({
  providedIn: 'root'
})
export class OperationProposalService {

  constructor(private http: HttpClient) {
  }

  findProposals(filter: SearchOperationsProposalModel) {

    let sizeQuery = '';
    let pageQuery = '';

    let query = new SearchOperationsProposalQueryModel();

    if (filter) {
      sizeQuery = filter.size ? `&size=${filter.size}` : '';
      pageQuery = filter.page ? `&page=${filter.page}` : '';
      if (filter.startDate && filter.startDate !== '') {
        query.startDate = filter.startDate;
      }
      if (filter.endDate && filter.endDate !== '') {
        query.endDate = filter.endDate;
      }
      if (filter.cpfCnpj && filter.cpfCnpj !== '') {
        query.cpfCnpj = filter.cpfCnpj;
      }
      if (filter.institution && filter.institution !== '') {
        query.institution = filter.institution;
      }
      if (filter.serviceContract && filter.serviceContract !== '') {
        query.serviceContract = filter.serviceContract;
      }
      if (filter.onlyPendingOperation) {
        query.onlyPendingOperationStatus = filter.onlyPendingOperation;
      } else {
        query.onlyPendingOperationStatus = false;
      }
      if (filter.statusOperation && filter.statusOperation !== '') {
        query.operationStatus = filter.statusOperation;
      }
      if (filter.technologyGroup && filter.technologyGroup !== '') {
        query.technologyGroup = filter.technologyGroup;
      }
      if (filter.logicNumber && filter.logicNumber !== '') {
        query.logicNumber = filter.logicNumber;
      }
    }
    let url = `${environment.apiUrls.operationsProposals}?1=1${sizeQuery}${pageQuery}`;

    return this.http.post<Pageable<OperationsProposalListModel[]>>(url, query);
  }

  getECommerceDetails(proposalNumber: string): Observable<OperationsProposalDetailModel> {
    return this.http.get<any>(`${environment.apiUrls.operationsProposalDetail}${proposalNumber}`).pipe(
      map(x => {
        if (!x) return null;
        if (Array.isArray(x)) {
          return <OperationsProposalDetailModel>{eCommerceDetails: x};
        }
        if (x.eCommerceDetails) {
          return x;
        }
        return <OperationsProposalDetailModel>{eCommerceDetails: [x]};
      })
    );
  }

  getTefDetails(proposalNumber: string): Observable<OperationsProposalDetailModel> {
    return this.http.get<OperationsProposalDetailModel>(`${environment.apiUrls.operationsProposalTefDetail}${proposalNumber}`).pipe(map(x => x ? <OperationsProposalDetailModel>{tefDetails: x} : null));
  }

  getEdiDetails(proposalNumber: string): Observable<OperationsProposalDetailModel> {
    return this.http.get<OperationsProposalDetailModel>(`${environment.apiUrls.operationsProposalEdiDetail}${proposalNumber}`).pipe(map(x => x ? <OperationsProposalDetailModel>{ediDetails: x} : null));
  }

  getPosSmartDetails(proposalNumber: string): Observable<OperationsProposalDetailModel> {
    return this.http.get<OperationsProposalDetailModel>(`${environment.apiUrls.operationsProposalDetailPosSmart}${proposalNumber}`).pipe(map(x => x ? <OperationsProposalDetailModel>{posSmartDetails: x} : null));
  }

  updateStatus(data: OperationsProposalUpdateModel): Observable<OperationsProposalUpdateModel> {
    return this.http.post<OperationsProposalUpdateModel>(`${environment.apiUrls.operationsProposalsUpdate}`, data);
  }

  getProposalNote(proposalNumber: string): Observable<CreditAndRiskProposalNoteModel[]> {
    return this.http.get<CreditAndRiskProposalNoteModel[]>(`${environment.apiUrls.creditRiskObservationSet}${proposalNumber}`);
  }

  getCreditRiskNote(proposalNumber: string): Observable<ProposalObservationNoteModel> {
    return this.http.get<any>(`${environment.apiUrls.creditRiskNote}${proposalNumber}`);
  }

  downloadOperationProposal(filter: ExportOperationsProposalModel) {
    let query = new SearchOperationsProposalQueryModel();

    if (filter.startDate && filter.startDate !== '') {
      query.startDate = filter.startDate;
    }
    if (filter.endDate && filter.endDate !== '') {
      query.endDate = filter.endDate;
    }
    if (filter.cpfCnpj && filter.cpfCnpj !== '') {
      query.cpfCnpj = filter.cpfCnpj;
    }
    if (filter.institution && filter.institution !== '') {
      query.institution = filter.institution;
    }
    if (filter.serviceContract && filter.serviceContract !== '') {
      query.serviceContract = filter.serviceContract;
    }
    if (filter.technologyGroup && filter.technologyGroup !== '') {
      query.technologyGroup = filter.technologyGroup;
    }
    if (filter.logicNumber && filter.logicNumber !== '') {
      query.logicNumber = filter.logicNumber;
    }

    return this.http.post<any>(`${environment.apiUrls.downloadOperationsProposals}`, query, {responseType: 'blob' as 'json'});
  }

  getPosSitefDetails(proposalNumber: string): Observable<OperationsProposalDetailModel> {
    return this.http.get<OperationsProposalDetailModel>(`${environment.apiUrls.operationsProposalDetailPosSitef}${proposalNumber}`).pipe(map(x => x ? <OperationsProposalDetailModel>{posSitefDetails: x} : null));
  }
}
